import { NotificationsAlertsService } from '@notifications/infra';
import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { GetNearbyGamesAlertsResponse } from '@core-http';
import { GetAlertsSettingsQueryResult } from './get-alerts-settings.query-result';
import { DEFAULT_ALERTS_SETTINGS } from '../../../utils';

export class GetAlertsSettingsQueryHandler {
  private notificationsAlertsService: NotificationsAlertsService = inject(NotificationsAlertsService);

  getAlertsSettings(): Observable<GetAlertsSettingsQueryResult> {
    return this.notificationsAlertsService
      .getAlerts()
      .pipe(map((dto: GetNearbyGamesAlertsResponse) => this.mapToQueryResult(dto)));
  }

  private mapToQueryResult(dto: GetNearbyGamesAlertsResponse): GetAlertsSettingsQueryResult {
    if (!dto) return DEFAULT_ALERTS_SETTINGS;

    return {
      isEnabled: dto.isEnabled ?? DEFAULT_ALERTS_SETTINGS.isEnabled,
      coordinates: dto.coordinates ?? DEFAULT_ALERTS_SETTINGS.coordinates,
      maxDistanceMeters: dto.maxDistanceMeters || DEFAULT_ALERTS_SETTINGS.maxDistanceMeters,
      time: dto.time ?? DEFAULT_ALERTS_SETTINGS.time,
      gameLevel: dto.gameLevel ?? DEFAULT_ALERTS_SETTINGS.gameLevel,
      specificWeekdays: dto.specificWeekdays ?? []
    };
  }
}
